import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// PAGINA 10 — Capitulo XIV (Barbacoa, condicional). Solo render si capitulosVisibles.barbacoa.
export default function BarbacoaPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const secNum = String(pagNum - 2).padStart(2, "0");
  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Amenities (2)</span>
        <h2 className="big">Uso de la <em>barbacoa.</em></h2>

        <div className="art">
          <div className="art-head">
            <div className="art-num">Capítulo {capRomanoMap.barbacoa}</div>
            <h3 className="art-title">Barbacoa — uso y reservas</h3>
          </div>
          <div className="hours-grid">
            {config.horarios.barbacoa.map((h) => (
              <div key={h.id} className="hours-card">
                <div className="lbl">{h.lbl}</div>
                <div className="val">{h.val}</div>
                {h.note && <div className="note">{h.note}</div>}
              </div>
            ))}
          </div>
          <h4 className="sub-h">Uso y funcionamiento</h4>
          <ol className="rules">
            <li><span className="m">a</span><span>Reserva al conserje o por correo de recepción; queda registrada.</span></li>
            <li><span className="m">b</span><span>Constancia con día, horario, unidad y responsable; presentar lista de invitados.</span></li>
            <li><span className="m">c</span><span>Reservas con hasta <b>90 días</b> de anticipación.</span></li>
            <li><span className="m">d</span><span>Limpieza incluida en alquiler. Suciedad excesiva: <b>cobro doble</b>.</span></li>
            <li><span className="m">e</span><span>Cancelación con <b>5 días</b> sin costo. Después: cobro como utilizada.</span></li>
            <li><span className="m">f</span><span><b>Prohibidas reuniones lucrativas</b>, profesionales o empresariales.</span></li>
            <li><span className="m">g</span><span>El responsable debe estar presente en todo momento.</span></li>
            <li><span className="m">h</span><span>Mobiliario solo a la parte techada de la terraza.</span></li>
            <li><span className="m">i</span><span>En festivos con varias reservas: sorteo con 30 días de anticipación.</span></li>
            <li><span className="m">j</span><span>Inventario al finalizar; entrega de llaves inmediata.</span></li>
            <li><span className="m">k</span><span>Reserva incluye <b>terraza anexa y jacuzzi</b>.</span></li>
            <li><span className="m">l</span><span>Edificio no responsable por accidentes ni lesiones.</span></li>
            <li><span className="m">m</span><span><b>Prohibida pirotecnia</b> en barbacoa y terraza.</span></li>
            <li><span className="m">n</span><span>Prohibido ingreso de invitados a cocheras (salvo propias).</span></li>
          </ol>
        </div>
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
